<template>
  <oido-button v-bind="$attrs" icon="download" @click.stop.prevent="download" :showSpinner="downloading"></oido-button>
</template>


<script setup>
import OidoButton from './OidoButton.vue'
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem'
import { AppLauncher } from '@capacitor/app-launcher';

</script>

<script>
import axios from "axios"


export default {
  props: ['url', 'filename'],
  data() {
    return {
      downloading: false
    }
  },
  methods: {
    async download() {
      if (this.downloading) {
        return
      }
      this.downloading = true

      let response = await axios.post(this.url, {}, {
        responseType: "arraybuffer",
      })

      const blob = new Blob([response.data])
      let filename = this.filename ? this.filename : 'no-name.txt'

      if (this.isApp) {
        var reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = async () => {
          var base64data = reader.result
          let result = await Filesystem.writeFile({
            path: filename,
            data: base64data,
            directory: Directory.Documents,
            // encoding: Encoding.UTF8,
          })
          let urlscheme = result.uri.replace('file://', 'shareddocuments://')
          await AppLauncher.openUrl({ url: urlscheme })
        }
      } else {
        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
      this.downloading = false


    }
  }

}

</script>
